module.exports = __webpack_public_path__ + "img/lr2.d4b63a63.png";